<template>
  <div>
    <config-bar />
    <div class="container mt-4" v-if="marshallConfig">
      <h1 class="text-center">{{$t("message.settings")}}</h1>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-hover table-striped table-bordered mt-4">
            <thead class="bg-primary">
              <tr>
                <th>{{$t("message.name")}}</th>
                <th>{{$t("message.address")}}</th>
                <th>{{$t("message.type")}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sherId of marshallConfig.sheriffs" :key="sherId.address">
                <editable-cell :id="sherId" @newEdit="editou" :content="sherId.label"></editable-cell>
                <td>{{sherId.address}}</td>
                <td>{{sherId.type}}</td>
                <td>
                  <button
                    class="btn btn-danger btn-cell"
                    @click="removeSheriff(sherId)"
                  >{{$t("message.remove")}}</button>
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    type="text"
                    v-model="sheriff.label"
                    class="form-control"
                    :placeholder="$t('message.insertName')"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    v-model="sheriff.address"
                    class="form-control"
                    :placeholder="$t('message.insertAddress')"
                  />
                </td>
                <td>
                  <select v-model="sheriff.type" class="form-control">
                    <option value="SERIAL">SERIAL</option>
                  </select>
                </td>
                <td>
                  <button
                    class="btn btn-primary btn-cell"
                    @click="addOrEditSheriff(sheriff)"
                  >{{$t('message.add')}}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../utils/api";
import EditableCell from "../resources/EditableCell";
import ConfigBar from "./ConfigBar";
let $api;

export default {
  name: "MarshallConfig",
  data() {
    return {
      marshallConfig: null,
      sheriff: {
        label: "",
        address: "",
        type: "SERIAL"
      }
    };
  },
  mounted() {
    $api = new API();
    $api
      .getMarshallConfig()
      .then(resp => {
        this.marshallConfig = resp.data;
      })
      .catch(e => {
        let status = e.response.status;
        if (status == 401 || status == 403) this.$router.push("/login");
      });
  },
  methods: {
    editou(id, newValue) {
      id.label = newValue;
      this.addOrEditSheriff(id);
    },
    addOrEditSheriff(sheriff) {
      $api.addSheriff(sheriff).then(r => {
        this.marshallConfig = r.data;
      });
    },
    removeSheriff(sheriff) {
      $api.deleteSheriff(sheriff).then(r => {
        this.marshallConfig = r.data;
      });
    }
  },
  components: {
    EditableCell,
    ConfigBar
  }
};
</script>

<style>
.btn-cell {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
</style>
